import styled from 'styled-components'

export const StartButton = styled.button<{ compact?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  font-weight: 600;
  background: ${({ theme }) => `rgb(${theme.component.background})`};
  color: ${({ theme }) => `rgb(${theme.grayscale?.['100'] || '249, 249, 249'})`};
  border: 1px solid ${({ theme }) => `rgb(${theme.component.background})`};
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 0.25rem;
  min-width: 100px;
  justify-content: center;

  &:hover {
    background: ${({ theme }) => `rgba(${theme.component.background}, 0.85)`};
  }

  svg {
    width: ${({ compact }) => (compact ? '24px' : '20px')};
    height: ${({ compact }) => (compact ? '24px' : '20px')};
  }

  @media (max-width: 768px) {
    padding: ${({ compact }) => (compact ? '8px' : '8px 16px')};
    font-size: 0.75rem;
    min-width: auto;

    span {
      display: none;
    }

    svg {
      width: ${({ compact }) => (compact ? '20px' : '18px')};
      height: ${({ compact }) => (compact ? '20px' : '18px')};
    }
  }
`
